/* Returns an array of time object that contain the provided industry key */
export const getIndustryTimes = (industryKey, times) => times.filter(time => time.industry_key === industryKey)

/* Returns an array of time object that contain the provided narrative key */
export const getNarrativeTimes = (narrativeKey, times) => times.filter(time => time.narrative_keys.includes(narrativeKey))

/* Returns a percentage value of a provided year based on where it falls between 1870 and 2020 */
export const getYearPercent = year => 100 - (100 * ((year - 1870) / 150))
